import React, { useContext, useMemo } from 'react'

import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { convertOccupancies, getDatesAndGuests, getOfferImageId, getSavedDetailsForOffer } from 'tripPlanner/components/Bookmark/BookmarkButton/utils'
import { useEditableTrips } from 'tripPlanner/hooks/api/trip'
import { EmptyArray } from 'lib/array/arrayUtils'
import SavePrompt from './SavePrompt'
import useNewTripNameFromOffer from 'tripPlanner/hooks/useNewTripNameFromOffer'
import { HotelBookmarkPayload } from 'tripPlanner/api/bookmark/types'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { BasicTrip } from 'tripPlanner/types/common'

interface Props {
  offer: App.HotelOffer | App.BedbankOffer
}

function SavePromptHotel({ offer }: Props) {
  const offerPageState = useContext(OfferPageStateContext)
  const datesAndGuests = getDatesAndGuests(offerPageState, undefined)

  const { data, isSuccess: tripsFetched } = useEditableTrips()
  const trips = data ?? EmptyArray as Array<BasicTrip>

  const details = getSavedDetailsForOffer(trips, offer.id)
  const isSaved = details.length > 0

  const newTripName = useNewTripNameFromOffer(offer)

  const bookmarkPayload = useMemo<HotelBookmarkPayload>(() => ({
    type: offer.type,
    code: offer.id,
    startDate: datesAndGuests.checkInDate?.format(ISO_DATE_FORMAT),
    endDate: datesAndGuests.checkOutDate?.format(ISO_DATE_FORMAT),
    occupancies: convertOccupancies(datesAndGuests.occupancies),
  }), [datesAndGuests, offer])

  if (isSaved || !tripsFetched) {
    return null
  }

  return <SavePrompt
    offerId={offer.id}
    offerTypeLabel="hotel"
    bookmarkPayload={bookmarkPayload}
    newTripName={newTripName}
    offerImageId={getOfferImageId(offer)}
    trips={trips}
  />
}

export default SavePromptHotel
